import { useEffect, useState } from "react";
import getNftLinkBonusOfferId from "@/actions/rewards/getNftLinkBonusOfferId";

const useMyBonusOffersNftLink = (context: WorkerContext) => {
  const [bonusOfferId, setBonusOfferId] = useState<string | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      const currency = context.currencyConfig.name;
      const id = await getNftLinkBonusOfferId(currency);
      if (id !== undefined) {
        setBonusOfferId(id);
      }
    };
    fetchData();
  }, [context]);

  return { bonusOfferId };
};

export default useMyBonusOffersNftLink;
